angular.module('GlobalHelpersModule').filter "roundToTenthWithDecimal", ->
  (input) ->
    input = input or ""

    # rounds to nearest tenth, this mimics current EHR behvavior
    decimal = "#{Math.round(input * 10) / 10}"
    if decimal.indexOf( '.', 0 ) < 0
      decimal += '.0'
    decimal